(() => {
  if (window.initCollectionInfiniteScroll) return;

  class CollectionInfiniteScroll {
    constructor(root) {
      this.root = root;
      this.grid = document.getElementById('product-grid');
      this.status = root.querySelector('.infinite-scroll__status');
      this.nextUrl = root.dataset.nextUrl;
      this.sectionId = root.dataset.sectionId;
      this.loading = false;
      this.aborted = false;

      if (!this.grid || !this.nextUrl) return;

      this.observer = new IntersectionObserver(this.onIntersect.bind(this), {
        rootMargin: '0px 0px 600px 0px',
        threshold: 0,
      });
      this.observer.observe(this.root);
    }

    onIntersect(entries) {
      if (entries.some((entry) => entry.isIntersecting)) {
        this.loadMore();
      }
    }

    async loadMore() {
      if (this.loading || this.aborted || !this.nextUrl) return;

      this.loading = true;
      this.root.classList.add('is-loading');
      this.root.setAttribute('aria-busy', 'true');
      if (this.status) this.status.hidden = false;

      this.controller = new AbortController();

      try {
        const url = new URL(this.nextUrl, window.location.origin);
        if (this.sectionId) url.searchParams.set('section_id', this.sectionId);

        const response = await fetch(url.toString(), { signal: this.controller.signal });
        if (!response.ok) throw new Error(`Failed to load products (${response.status})`);

        const html = await response.text();
        if (this.aborted) return;

        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newGrid = doc.getElementById('product-grid');
        const newSentinel = doc.querySelector('.infinite-scroll');
        const newItems = newGrid ? Array.from(newGrid.querySelectorAll(':scope > .grid__item')) : [];

        newItems.forEach((item) => {
          item.classList.add('scroll-trigger--cancel');
          this.grid.appendChild(item);
        });

        const nextUrl = newSentinel?.dataset.nextUrl;
        if (nextUrl && newItems.length) {
          this.nextUrl = nextUrl;
          this.root.dataset.nextUrl = nextUrl;
        } else {
          this.nextUrl = '';
          this.destroy();
          this.root.remove();
          return;
        }
      } catch (error) {
        if (error.name === 'AbortError') return;
        console.error(error);
      } finally {
        this.loading = false;
        if (this.root.isConnected) {
          this.root.classList.remove('is-loading');
          this.root.removeAttribute('aria-busy');
          if (this.status && this.nextUrl) this.status.hidden = true;
        }
      }

      // Retrigger if the sentinel is still in view (short collections / tall screens).
      if (this.nextUrl && this.observer && this.root.isConnected) {
        this.observer.unobserve(this.root);
        this.observer.observe(this.root);
      }
    }

    destroy() {
      this.aborted = true;
      if (this.controller) this.controller.abort();
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    }
  }

  window.initCollectionInfiniteScroll = function initCollectionInfiniteScroll() {
    if (window.collectionInfiniteScroll) {
      window.collectionInfiniteScroll.destroy();
      window.collectionInfiniteScroll = null;
    }

    const root = document.querySelector('.infinite-scroll');
    if (!root) return;

    window.collectionInfiniteScroll = new CollectionInfiniteScroll(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', window.initCollectionInfiniteScroll);
  } else {
    window.initCollectionInfiniteScroll();
  }
})();
